import {PropsWithChildren} from 'react'
import Announcement from '@/components/common/Announcement/Announcement'
import {COLORS} from "@/components/common/Announcement/utils";

interface ErrorComponentProps extends PropsWithChildren {
	res?:Response
	statusCode?:number
	type?:keyof typeof COLORS
	title?:string
	subTitle?:string
}

export const ErrorComponent = ({
							 statusCode,
	                         type,
	                         title,
	                         subTitle,
	                         children
                         }:ErrorComponentProps) => {

	let overrideTitle: string | undefined = undefined
	let overrideSubtitle = subTitle || 'An error has occurred.'

	if (statusCode) {
		overrideTitle = statusCode.toString()

		switch (overrideTitle) {
			case '404':
				overrideSubtitle = 'Not Found'
				break
			case '500':
				overrideSubtitle = 'Internal Server Error'
				break
			default:
				break
		}
	}

	return (
		<Announcement
			type={type || 'error'}
			title={overrideTitle || title}
			subTitle={overrideSubtitle || subTitle}
		>
			{children}
		</Announcement>
	)
}
